import { ProbationFormState } from "../ProbationAssessmentForm";

interface OutcomeOption {
  key: string;
  label: string;
  subLabel: string | null;
  name: keyof ProbationFormState;
  rows: number;
  hasDate: boolean;
  dateName?: keyof ProbationFormState; // ✅ optional, only on option B
}

export const probationFormFields = [
  // {
  //   label: "Name of Employee:",
  //   name: "employeeName",
  //   type: "text",
  //   disabled: false,
  // },
  {
    label: "Employee Code:",
    name: "employeeCode",
    type: "text",
    disabled: true,
  },
  {
    label: "Date of Appointment:",
    name: "dateOfAppointment",
    type: "date",
    disabled: false,
  },
  { label: "Designation:", name: "designation", type: "text", disabled: true },
  { label: "Function:", name: "function", type: "text", disabled: false },
  {
    label: "Period of Probation:",
    name: "periodOfProbation",
    type: "text",
    disabled: false,
  },
  { label: "Location:", name: "location", type: "text", disabled: false },
  {
    label: "Due for confirmation:",
    name: "dueForConfirmation",
    type: "date",
    disabled: false,
  },
];

export const attendanceOptions = [
  "Nearly always late",
  "Usually late",
  "Usually punctual",
  "Never or hardly late",
];

export const assessmentSections = [
  {
    section: "A. ABILITY TO LEARN",
    description:
      "Consider ease and rapidity of understanding new instructions and adapting to new situations.",
    name: "abilityToLearn",
    options: [
      "Dull and adaptable",
      "Below Average",
      "Average",
      "Above Average",
      "Exceptional",
    ],
  },
  {
    section: "B. INDUSTRY",
    description:
      "Consider energy and application to duties day-in and day-out.",
    name: "industry",
    options: [
      "Lazy",
      "Indifferent",
      "Average",
      "Industrious",
      "Unusually Energetic",
    ],
  },
  {
    section: "C. INITIATIVE",
    description:
      "Consider ability to go ahead with work, without being told every detail, and to make practical suggestions for doing work in a better way.",
    name: "initiative",
    options: [
      "Needs Constant Direction",
      "No Originality",
      "Average",
      "Above Average",
      "Highly Constructive",
    ],
  },
  {
    section: "D. CO-OPERATIVENESS",
    description:
      "Consider ability to maintain good working relation with co-workers.",
    name: "cooperativeness",
    options: [
      "Trouble-maker",
      "Causes Slight Friction",
      "Indifferent",
      "Co-operative",
      "Exceptionally Co-operative",
    ],
  },
  {
    section: "E. ACCURACY",
    description: "Consider ability to do work without errors.",
    name: "accuracy",
    options: [
      "Unsatisfactory",
      "Makes Many Errors",
      "Average",
      "Seldom Makes Errors",
      "Exceptionally Accurate",
    ],
  },
  {
    section: "F. ABILITY TO SUPERVISE",
    description: "Consider ability to direct the work of others effectively.",
    name: "abilityToSupervise",
    options: [
      "Dull and adaptable",
      "Below Average",
      "Average",
      "Above Average",
      "Exceptional",
    ],
  },
  {
    section: "G. KNOWLEDGE OF WORK",
    description: "Consider knowledge in the field of work.",
    name: "knowledgeOfWork",
    options: [
      "Dull and adaptable",
      "Below Average",
      "Average",
      "Above Average",
      "Exceptional",
    ],
  },
];

export const probationOutcomeOptions: OutcomeOption[] = [
  {
    key: "A",
    label: "Extension of Probation (max up to 3 month)",
    subLabel: "(Give detailed reasons)",
    name: "extensionReason",
    rows: 2,
    hasDate: false,
  },
  {
    key: "B",
    label: "Services to be terminated with effect from:",
    subLabel: "(Give detailed reasons)",
    name: "terminationReason",
    rows: 2,
    hasDate: true,
    dateName: "terminationDate" as const, // ✅ only here
  },
  {
    key: "C",
    label: "Employee to be Confirmed with Remarks:",
    subLabel: null,
    name: "confirmationRemarks",
    rows: 2,
    hasDate: false,
  },
];
